interface IUserLoginInfo {
}

export class ApplicationSettings {

    static get instance(): ApplicationSettings {
        return applicationSettings;
    } 

    get user(): IUserLoginInfo {
        return __currentUser;
    }

    public showInactive: boolean = false;
}

var __currentUser: IUserLoginInfo = null;
export var applicationSettings: ApplicationSettings = new ApplicationSettings();



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/coresettings.ts